import React from 'react';
import { ArrowRight } from 'lucide-react';

interface HelpCenterCardProps {
  article_id: string;
  title: string;
  description: string;
  slug: string;
  url?: string;
  thumbnail?: string;
  brandColor: string;
  isDark: boolean;
  onReadClick: (slug: string) => void;
}

const HelpCenterCard: React.FC<HelpCenterCardProps> = ({
  title,
  description,
  slug,
  thumbnail,
  brandColor,
  isDark,
  onReadClick,
}) => {
  return (
    <div
      className={`not-prose rounded-xl overflow-hidden border my-2 transition-colors ${
        isDark
          ? 'bg-gray-900 border-gray-700 hover:bg-gray-800'
          : 'bg-white border-gray-200 hover:bg-gray-50'
      }`}
      style={{ borderLeftWidth: '4px', borderLeftColor: brandColor }}
    >
      <div className="flex items-start gap-3 p-3">
        {/* Content */}
        <div className="flex-1 min-w-0">
          <h4
            className="text-sm font-semibold leading-snug line-clamp-2"
            style={{ color: isDark ? '#ffffff' : '#111827' }}
          >
            {title}
          </h4>
          <p
            className="text-xs mt-1 line-clamp-2"
            style={{ color: isDark ? '#9ca3af' : '#6b7280' }}
          >
            {description}
          </p>
          {slug && slug.trim() ? (
            <button
              onClick={() => onReadClick(slug)}
              className="mt-2 inline-flex items-center gap-1 text-xs font-medium transition-colors"
              style={{ color: brandColor }}
            >
              Read <ArrowRight className="w-3 h-3" />
            </button>
          ) : null}
        </div>

        {/* Thumbnail */}
        {thumbnail && (
          <div className="flex-shrink-0 w-16 h-16 rounded-lg overflow-hidden">
            <img
              src={thumbnail}
              alt={title}
              className="w-full h-full object-cover"
            />
          </div>
        )}
      </div>
    </div>
  );
};

export default HelpCenterCard;
